module.exports = __webpack_public_path__ + "media/images/download-zip-777736f45ab4d4d1e81cc848b15dd7a2.png";